import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsLangMenuOpen(false);
  };

  const getLanguageName = (code) => {
    const names = { de: 'Deutsch', en: 'English', tr: 'Türkçe', ar: 'العربية' };
    return names[code];
  };

  const getLanguageFlag = (code) => {
    const flags = { de: '🇩🇪', en: '🇬🇧', tr: '🇹🇷', ar: '🇸🇦' };
    return flags[code];
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/PasaLebensmittelLogo.jpg" alt="Paşa Lebensmittel" />
        </Link>

        <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            {t('nav.home')}
          </Link>
          <Link 
            to="/about" 
            className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            {t('nav.about')}
          </Link>
          <Link 
            to="/products" 
            className={`nav-link ${location.pathname === '/products' ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            {t('nav.products')}
          </Link>
          <Link 
            to="/contact" 
            className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            {t('nav.contact')}
          </Link>
          <a 
            href="https://b2b.pasalebensmittel.de" 
            className="nav-link b2b-link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMobileMenu}
          >
            {t('nav.b2b')}
          </a>

          <div className="language-selector">
            <button 
              className="lang-button"
              onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
            >
              <span className="flag-icon">{getLanguageFlag(i18n.language)}</span>
              <span>{getLanguageName(i18n.language)}</span>
            </button>
            {isLangMenuOpen && (
              <div className="lang-dropdown">
                <button onClick={() => changeLanguage('de')}>
                  <span className="flag-icon">🇩🇪</span> Deutsch
                </button>
                <button onClick={() => changeLanguage('en')}>
                  <span className="flag-icon">🇬🇧</span> English
                </button>
                <button onClick={() => changeLanguage('tr')}>
                  <span className="flag-icon">🇹🇷</span> Türkçe
                </button>
                <button onClick={() => changeLanguage('ar')}>
                  <span className="flag-icon">🇸🇦</span> العربية
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

